// extracted by mini-css-extract-plugin
module.exports = {"toggle__button":"ThemeButton_toggle__button__EsDAR"};